import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { googleAuth } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');
    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const userData = await googleAuth(sessionId);
        if (userData?.role === 'admin') {
          navigate('/admin', { state: { user: userData } });
        } else if (userData?.status === 'pending' || !userData?.industries?.length) {
          navigate('/onboarding', { state: { user: userData } });
        } else {
          navigate('/dashboard', { state: { user: userData } });
        }
      } catch {
        navigate('/login');
      }
    })();
  }, [googleAuth, navigate]);

  return (
    <div className="min-h-screen bg-[#090E33] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#FF4343] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#9CA3AF] text-sm font-mono">Authenticating...</p>
      </div>
    </div>
  );
}
